// Pre-rendered sign swatches from `static/`, shared by legendHelpers.ts and layerConfig.ts; asset() keeps them working under a base path.
import { asset } from '$app/paths';

export const SIGN_LEVELS = (['Required', 'Recommended', 'Optional'] as const).map(
	(level) => [level, asset(`images/safecurves/W1-1_${level}_Left.png`)] as const
);
export const signSpeed = asset('images/safecurves/W13-1P_35.png');
